module.exports = __webpack_public_path__ + "img/pulse-of-europe-logo.3f2e4a03.png";